export const QUERY_KEY_NAME_PAGE = 'page';
export const QUERY_KEY_NAME_SORT_DIR = 'sort_dir';
export const QUERY_KEY_NAME_SORT = 'sort';

export const PRODUCT_LIST_VIEW_KEY = 'product-list-view';
